import awards from "../../shared/pt.awards";
import branded_quotes from "../../shared/pt.branded-quotes";
import verticals from "./pt-education-secondary.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "pt-education-secondary-404":
            return {
                page,
                helmet: {
                    meta_title: "Página não encontrada | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://pt.rosettastone.com/404",
                    lang: "pt"
                },
                ...pageFooter({ strings })
            };
        case "pt-education-secondary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contato | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://pt.rosettaston.com/ensino-superior/contato/",
                    lang: "pt"
                },
                eloquaPage: "webpage",
                ...pageFooter({ strings })
            };
        case "pt-education-secondary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "Centro de recursos | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
                    canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "pt-education-secondary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "Centro de recursos\n | Rosetta Stone",
                    meta_description:
                        "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
                    canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "pt-education-secondary-home":
            return {
                page,
                helmet: {
                    meta_title: "Aprendizado de idiomas on-line no ensino superior | Rosetta Stone",
                    meta_description:
                        "As soluções de aprendizado de idiomas da Rosetta Stone no ensino superior oferece aos alunos acesso on-line instantâneo para o aprendizado de inglês e outros idiomas. Solicite informações.",
                    canonical_url: "https://pt.rosettastone.com/ensino-superior/",
                    lang: "pt"
                },
                ...pageFooter({ strings })
            };
        case "pt-education-secondary-solutions":
            return {
                page,
                helmet: {
                    meta_title:
                        "Programas de aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
                    meta_description:
                        "Os programas de aprendizado de idiomas on-line da Rosetta Stone incentivam os alunos de inglês e outros idiomas a falar com segurança. Pergunte os preços.",
                    canonical_url: "https://pt.rosettastone.com/educacaobasica/solucoes/",
                    lang: "pt"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
